export const ApiSettingsSeason = (axios, obuBaseUrl) => {
  axios.setBaseURL(obuBaseUrl)

  const save = async (id, payload) => {
    const result = await axios.post(`/api/settings/seasons/${id}`, payload)
    return result.data
  }

  const find = async (id) => {
    const result = await axios.get(`/api/settings/seasons/${id}`)
    return result.data
  }

  const remove = async (id) => {
    const result = await axios.delete(`/api/settings/seasons/${id}`)
    return result.data
  }

  const load = async () => {
    const result = await axios.get('/api/settings/seasons')
    return result.data
  }

  return {
    seasonsFind: find,
    seasonsLoad: load,
    seasonsRemove: remove,
    seasonsSave: save
  }
}
